document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-largemediacallout").forEach((el) => {
    const trigger = el.querySelector(".video-trigger");

    if (!trigger) {
      return;
    }

    trigger.addEventListener("click", () => {
      trigger.classList.add("is-active");

      const video = trigger.querySelector("video");

      if (video) {
        video.play();
      }
    });
  });
});
